<footer>
  <div *ngIf="showBackToTop" class="container mt-4 mb-5">
    <app-back-to-top [target]="target"></app-back-to-top>
  </div>
  <div class="bg-primary text-white">
    <div class="py-5">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 mb-5 mb-sm-0">
            <h3>Navigate</h3>
            <ul class="list-unstyled mb-0">
              <li>
                <a routerLink="/explore-map/egm-erm-basemap">Explore Map</a>
              </li>
              <li>
                <a routerLink="/access-data">Access Data</a>
              </li>
              <li>
                <a routerLink="/frequently-asked-questions">Frequently Asked Questions</a>
              </li>
              <li>
                <a routerLink="/contact">Contact Us</a>
              </li>
              <li>
                <a routerLink="/accessibility">Accessibility</a>
              </li>
              <li>
                <a routerLink="/privacy-policy">Privacy</a>
              </li>
              <li>
                <a routerLink="/terms-conditions">Terms & Conditions</a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-md-6">
            <h3>Contact</h3>
            <ul class="list-unstyled mb-0">
              <li>
                e:
                <a href="mailto:contact@eurogeographics.org">contact@eurogeographics.org</a>
              </li>
              <li>t: +32 2 888 71 93</li>
              <li>
                <p class="footer__address">
                  EuroGeographics AISBL <br />
                  Head Office<br />
                  Rue du Nord 76/Noordstraat 76<br />
                  1000 Brussels<br />
                  BELGIUM
                </p>
              </li>
              <li>
                <ul class="list-unstyled d-flex flex-wrap">
                  <li class="me-3">
                    <a
                      href="https://twitter.com/EuroGeographics"
                      target="_blank"
                      class="btn btn-icon-only"
                    >
                      <img
                        src="../../../assets/els/images/logos/icon-twitter.svg"
                        alt="Twitter"
                        width="40"
                        height="40"
                        placement="top"
                        ngbTooltip="Twitter"
                        [openDelay]="1000"
                      />
                    </a>
                  </li>
                  <li class="me-3">
                    <a
                      href="https://www.linkedin.com/company/eurogeographics-aisbl/"
                      target="_blank"
                      class="btn btn-icon-only"
                    >
                      <img
                        src="../../../assets/els/images/logos/icon-linkedin.svg"
                        alt="Linkedin"
                        width="40"
                        height="40"
                        placement="top"
                        ngbTooltip="LinkedIn"
                        [openDelay]="1000"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/user/EuroGeographics"
                      target="_blank"
                      class="btn btn-icon-only"
                    >
                      <img
                        src="../../../assets/els/images/logos/icon-youtube.svg"
                        alt="YouTube"
                        width="40"
                        height="40"
                        placement="top"
                        ngbTooltip="YouTube"
                        [openDelay]="1000"
                      />
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="bg-black text-white p-3">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6 d-flex align-items-center">
          <p class="m-0">&copy; 2024 EuroGeographics</p>
        </div>
        <div class="col-12 col-md-6">
          <img
            class="mt-3 mt-sm-0"
            width="160"
            height="36"
            src="../../../assets/els/images/logos/co-funded-by-the-european-union_footer.png"
            alt="Co-funded by the European Union"
          />
        </div>
      </div>
    </div>
  </div>
</footer>
